import { Box, Tooltip } from '@mui/material';
import Copy from 'components/Copy';
import { DataCellProps } from '../types';

const MembersV2DetailsRowCell = ({ member }: DataCellProps) => {
  // Handle both API response formats:
  // - Modern format: { id, lastBackfilled }
  // - Legacy format: { account_id, team_membership_id, last_active }
  const memberId =
    member.id ||
    (member as any).account_id?.toString() ||
    (member as any).team_membership_id?.toString() ||
    '';
  const lastBackfilled = member.lastBackfilled || (member as any).last_active || '';

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: 'rgba(0, 0, 0, 0.15)',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        textAlign: 'left',
      }}
    >
      <Box display="flex" flexWrap="wrap" alignItems="flex-start" gap={3}>
        {/* Left: UUID with copy (icon close to value) */}
        <Box flex="1 1 50%" minWidth={320}>
          <Box
            sx={{
              color: 'text.secondary',
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              mb: 1,
            }}
          >
            UUID
          </Box>
          <Box display="flex" alignItems="center" minWidth={0}>
            <Box
              sx={{
                wordBreak: 'break-all',
                fontFamily: 'monospace',
                fontSize: '0.875rem',
                color: 'text.primary',
                lineHeight: 1.5,
              }}
            >
              {memberId || 'N/A'}
            </Box>
            {memberId ? (
              <Box ml={1.5} display="flex" alignItems="center">
                <Tooltip title="Copy UUID">
                  <span>
                    <Copy textToCopy={memberId} />
                  </span>
                </Tooltip>
              </Box>
            ) : null}
          </Box>
        </Box>

        {/* Right: Last Backfilled / Last Active */}
        <Box flex="1 1 50%" minWidth={220}>
          <Box
            sx={{
              color: 'text.secondary',
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              mb: 1,
            }}
          >
            Last Backfilled
          </Box>
          <Box
            sx={{
              fontSize: '0.875rem',
              color: 'text.primary',
              lineHeight: 1.5,
            }}
          >
            {lastBackfilled || 'N/A'}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MembersV2DetailsRowCell;
